module.exports = __webpack_public_path__ + "static/media/right.baec41f3.svg";